import React from "react";
import styled, { keyframes } from "styled-components";
import { Heading } from "../";

const appearOnLeft = keyframes`
  0% {
    transform: translateX(-1000px);
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  100% {
    transform: translateX(0);
  }
`;

const StyledAboutItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Text = styled.div`
  font-weight: normal;
  font-size: 16px;
  color: #ffffff;
  animation-name: ${appearOnLeft};
  animation-duration: 0.5s;
  animation-delay: ${({ animationDelay }) => `${0.1 * animationDelay}s` || 0};
`;

export const AboutItem = ({ title, text, animationDelay }) => {
  return (
    <StyledAboutItem>
      <Heading as="h2" tagStyle="h4" color="#fffa79">
        {title}
      </Heading>
      <Text animationDelay={animationDelay}>{text}</Text>
    </StyledAboutItem>
  );
};
